module.exports = __webpack_public_path__ + "img/Group 2646.b3b11576.svg";